<template>
  <div class="banner">
    <img class="banner__img" :src="competition.bannerImgUrl" alt="" />
  </div>
</template>

<script>
export default {
  name: "Banner",
  props: ["competition"],
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.banner {

  &__img {
    display: block;
    width: 100%;
    height: 500px;
    object-fit: cover;
  }
}

/* .title {
  font-size: 48px;
  color: #ffffff;
  line-height: 65px;
  padding-top: 174px;
  margin-bottom: 24px;
}
.content {
  font-size: 28px;
  color: rgba(255, 255, 255, 0.8);
  line-height: 42px;
} */
</style>
